<div class="modalContainer" fxLayout="column" fxLayoutAlign="center center">
  <div>
    <p>{{data}}</p>
  </div>
  <div>
    <button mat-flat-button color="accent" (click)="close()">{{'close' | translation}}</button>
  </div>
</div>
